const claritySetup = () => {
  if (!import.meta.env.VITE_CLARITY_ID) return;

  const clarityScript = `
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${import.meta.env.VITE_CLARITY_ID}");
  `;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.innerHTML = clarityScript;
  script.async = true;

  document.head.appendChild(script);
};

export default claritySetup;
